// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"ProductReturnsAccordion_accordionTitle__otXyw"};